const { createSelector } = require('reselect')

const selectAdminConsultationsList = state => state.consultations.adminConsultationsList

const getAdminConsultationsList = () => createSelector(
  [selectAdminConsultationsList],
  cse => cse.data,
)

const getAdminConsultationsListError = () => createSelector(
  [selectAdminConsultationsList],
  cse => cse.error,
)

const getAdminConsultationsListLoading = () => createSelector(
  [selectAdminConsultationsList],
  cse => cse.loading,
)

const selectAdminConsultation = state => state.consultations.adminConsultation

const getAdminConsultation = () => createSelector(
  [selectAdminConsultation],
  cse => cse.data,
)

const getAdminConsultationError = () => createSelector(
  [selectAdminConsultation],
  cse => cse.error,
)

const getAdminConsultationLoading = () => createSelector(
  [selectAdminConsultation],
  cse => cse.loading,
)

const selectCreateAdminConsultation = state => state.consultations.createAdminConsultation

const getCreateAdminConsultation = () => createSelector(
  [selectCreateAdminConsultation],
  cse => cse.data,
)

const getCreateAdminConsultationError = () => createSelector(
  [selectCreateAdminConsultation],
  cse => cse.error,
)

const getCreateAdminConsultationLoading = () => createSelector(
  [selectCreateAdminConsultation],
  cse => cse.loading,
)
const selectUpdateAdminConsultation = state => state.consultations.updateAdminConsultation

const getUpdateAdminConsultation = () => createSelector(
  [selectUpdateAdminConsultation],
  cse => cse.data,
)

const getUpdateAdminConsultationError = () => createSelector(
  [selectUpdateAdminConsultation],
  cse => cse.error,
)

const getUpdateAdminConsultationLoading = () => createSelector(
  [selectUpdateAdminConsultation],
  cse => cse.loading,
)

const selectDeleteAdminConsultation = state => state.consultations.deleteAdminConsultation

const getDeleteAdminConsultationRes = () => createSelector(
  [selectDeleteAdminConsultation],
  cse => cse.data,
)

const getDeleteAdminConsultationError = () => createSelector(
  [selectDeleteAdminConsultation],
  cse => cse.error,
)

const getDeleteAdminConsultationLoading = () => createSelector(
  [selectDeleteAdminConsultation],
  cse => cse.loading,
)

const selectUpdateStatusAdminConsultation = state => state.consultations.updateStatusAdminConsultation

const getUpdateStatusAdminConsultation = () => createSelector(
  [selectUpdateStatusAdminConsultation],
  cse => cse.data,
)

const getUpdateStatusAdminConsultationError = () => createSelector(
  [selectUpdateStatusAdminConsultation],
  cse => cse.error,
)

const getUpdateStatusAdminConsultationLoading = () => createSelector(
  [selectUpdateStatusAdminConsultation],
  cse => cse.loading,
)

const selectConsultation = state => state.consultations.consultationList

const getConsultationsList = () => createSelector(
  [selectConsultation],
  cse => cse.data,
)

const getConsultationsListError = () => createSelector(
  [selectConsultation],
  cse => cse.error,
)

const getConsultationsListLoading = () => createSelector(
  [selectConsultation],
  cse => cse.loading,
)

const selectAvailableConsultationsList = state => state.consultations.availableConsultationsList
const getAvailableConsultationsList = () => createSelector(
  [selectAvailableConsultationsList],
  cse => cse.data,
)

const getAvailableConsultationsListError = () => createSelector(
  [selectAvailableConsultationsList],
  cse => cse.error,
)

const getAvailableConsultationsListLoading = () => createSelector(
  [selectAvailableConsultationsList],
  cse => cse.loading,
)

const selectCreateConsultation = state => state.consultations.createConsultation
const createConsultation = () => createSelector(
  [selectCreateConsultation],
  cse => cse.data,
)

const createConsultationError = () => createSelector(
  [selectCreateConsultation],
  cse => cse.error,
)

const createConsultationLoading = () => createSelector(
  [selectCreateConsultation],
  cse => cse.loading,
)

const selectConsultationHistory = state => state.consultations.consultationHistoryList

const getConsultationsHistoryList = () => createSelector(
  [selectConsultationHistory],
  cse => cse.data,
)

const getConsultationsHistoryListError = () => createSelector(
  [selectConsultationHistory],
  cse => cse.error,
)

const getConsultationsHistoryListLoading = () => createSelector(
  [selectConsultationHistory],
  cse => cse.loading,
)

const selectConsultationHistoryDetails = state => state.consultations.consultationHistoryDetails

const getConsultationHistoryDetails = () => createSelector(
  [selectConsultationHistoryDetails],
  cse => cse.data,
)

const getConsultationHistoryLoading = () => createSelector(
  [selectConsultationHistoryDetails],
  cse => cse.loading,
)

const getConsultationHistoryError = () => createSelector(
  [selectConsultationHistoryDetails],
  cse => cse.error,
)

const selectDoctorConsultationHistoryList = state => state.consultations.doctorConsultationHistoryList

const getDoctorConsultationHistoryList = () => createSelector(
  [selectDoctorConsultationHistoryList],
  cse => cse.data,
)

const getDoctorConsultationHistoryListLoading = () => createSelector(
  [selectDoctorConsultationHistoryList],
  cse => cse.loading,
)

const getDoctorConsultationHistoryListError = () => createSelector(
  [selectDoctorConsultationHistoryList],
  cse => cse.error,
)

const selectDoctorConsultationOverview = state => state.consultations.doctorConsultationOverview

const getDoctorConsultationOverview = () => createSelector(
  [selectDoctorConsultationOverview],
  cse => cse.data,
)

const getDoctorConsultationOverviewLoading = () => createSelector(
  [selectDoctorConsultationOverview],
  cse => cse.loading,
)

const getDoctorConsultationOverviewError = () => createSelector(
  [selectDoctorConsultationOverview],
  cse => cse.error,
)

const selectAssignDocToConsultation = state => state.consultations.assignDocToConsultation

const assignDocToConsultationData = () => createSelector(
  [selectAssignDocToConsultation],
  cse => cse.data,
)

const assignDocToConsultationLoading = () => createSelector(
  [selectAssignDocToConsultation],
  cse => cse.loading,
)

const assignDocToConsultationError = () => createSelector(
  [selectAssignDocToConsultation],
  cse => cse.error,
)

const selectSetConsultationPreferenceState = state => state.consultations.setConsultationPreference
const selectSetConsultationPreference = () => createSelector(
  [selectSetConsultationPreferenceState],
  cse => cse.data,
)

const selectSetConsultationPreferenceLoading = () => createSelector(
  [selectSetConsultationPreferenceState],
  cse => cse.loading,
)

const selectSetConsultationPreferenceError = () => createSelector(
  [selectSetConsultationPreferenceState],
  cse => cse.error,
)

const selectGetPatientConsultationRecordState = state => state.consultations.patientConsultationRecord
const selectPatientConsultationRecord = () => createSelector(
  [selectGetPatientConsultationRecordState],
  cse => cse.data,
)

const selectPatientConsultationRecordLoading = () => createSelector(
  [selectGetPatientConsultationRecordState],
  cse => cse.loading,
)

const selectPatientConsultationRecordError = () => createSelector(
  [selectGetPatientConsultationRecordState],
  cse => cse.error,
)

const selectPostDoctorNotesState = state => state.consultations.postDoctorNotesState
const selectPostDoctorNotes = () => createSelector(
  [selectPostDoctorNotesState],
  cse => cse.data,
)

const selectPostDoctorNotesLoading = () => createSelector(
  [selectPostDoctorNotesState],
  cse => cse.loading,
)

const selectPostDoctorNotesError = () => createSelector(
  [selectPostDoctorNotesState],
  cse => cse.error,
)

const selectPostDoctorMCState = state => state.consultations.postDoctorMCState
const selectPostDoctorMC = () => createSelector(
  [selectPostDoctorMCState],
  cse => cse.data,
)

const selectPostDoctorMCLoading = () => createSelector(
  [selectPostDoctorMCState],
  cse => cse.loading,
)

const selectPostDoctorMCError = () => createSelector(
  [selectPostDoctorMCState],
  cse => cse.error,
)

const selectPostDoctorReferralState = state => state.consultations.postDoctorReferralState
const selectPostDoctorReferral = () => createSelector(
  [selectPostDoctorReferralState],
  cse => cse.data,
)

const selectPostDoctorReferralLoading = () => createSelector(
  [selectPostDoctorReferralState],
  cse => cse.loading,
)

const selectPostDoctorReferralError = () => createSelector(
  [selectPostDoctorReferralState],
  cse => cse.error,
)

const selectEndDoctorConsultationState = state => state.consultations.endDoctorConsultationState
const selectEndDoctorConsultationData = () => createSelector(
  [selectEndDoctorConsultationState],
  cse => cse.data,
)

const selectEndDoctorConsultationLoading = () => createSelector(
  [selectEndDoctorConsultationState],
  cse => cse.loading,
)

const selectEndDoctorConsultationError = () => createSelector(
  [selectEndDoctorConsultationState],
  cse => cse.error,
)

const selectAudioCallByDocState = state => state.consultations.sendAudioCallRequestByDoctorState
const selectAudioCallByDocData = () => createSelector(
  [selectAudioCallByDocState],
  cse => cse.data,
)

const selectAudioCallByDocDataLoading = () => createSelector(
  [selectAudioCallByDocState],
  cse => cse.loading,
)

const selectAudioCallByDocDataError = () => createSelector(
  [selectAudioCallByDocState],
  cse => cse.error,
)

const selectGetDoctorTwilioTokensState = state => state.consultations.getDoctorTwilioTokenState
const selectGetDoctorTwilioTokensData = () => createSelector(
  [selectGetDoctorTwilioTokensState],
  cse => cse.data,
)

const selectGetDoctorTwilioTokensDataLoading = () => createSelector(
  [selectGetDoctorTwilioTokensState],
  cse => cse.loading,
)

const selectGetDoctorTwilioTokensDataError = () => createSelector(
  [selectGetDoctorTwilioTokensState],
  cse => cse.error,
)

const selectPostDocConsultationTimeLapsedState = state => state.consultations.postConsultationTimeLapsedState
const selectPostDocConsultationTimeLapsedData = () => createSelector(
  [selectPostDocConsultationTimeLapsedState],
  cse => cse.data,
)

const selectPostDocConsultationTimeLapsedLoading = () => createSelector(
  [selectPostDocConsultationTimeLapsedState],
  cse => cse.loading,
)

const selectPostDocConsultationTimeLapsedError = () => createSelector(
  [selectPostDocConsultationTimeLapsedState],
  cse => cse.error,
)

const selectMDReferralNewLinkState = state => state.consultations.getMDReferralNewLinkState
const selectMDReferralNewLinkData = () => createSelector(
  [selectMDReferralNewLinkState],
  cse => cse.data,
)

const selectMDReferralNewLinkDataLoading = () => createSelector(
  [selectMDReferralNewLinkState],
  cse => cse.loading,
)

const selectMDReferralNewLinkDataError = () => createSelector(
  [selectMDReferralNewLinkState],
  cse => cse.error,
)

const selectMDMcNewLinkState = state => state.consultations.getMDMcNewLinkState
const selectMDMcNewLinkData = () => createSelector(
  [selectMDMcNewLinkState],
  cse => cse.data,
)

const selectMDMcNewLinkDataLoading = () => createSelector(
  [selectMDMcNewLinkState],
  cse => cse.loading,
)

const selectMDMcNewLinkDataError = () => createSelector(
  [selectMDMcNewLinkState],
  cse => cse.error,
)

const selectPatientConsultationStatusState = state => state.consultations.checkPatientConsultationStatusState
const selectPatientConsultationStatusData = () => createSelector(
  [selectPatientConsultationStatusState],
  cse => cse.data,
)

const selectPatientConsultationStatusDataLoading = () => createSelector(
  [selectPatientConsultationStatusState],
  cse => cse.loading,
)

const selectPatientConsultationStatusDataError = () => createSelector(
  [selectPatientConsultationStatusState],
  cse => cse.error,
)

const selectVerifyTransactionAmountState = state => state.consultations.verifyTransactionAmountState
const verifyTransactionAmountStateData = () => createSelector(
  [selectVerifyTransactionAmountState],
  cse => cse.data,
)

const verifyTransactionAmountStateDataLoading = () => createSelector(
  [selectVerifyTransactionAmountState],
  cse => cse.loading,
)

const verifyTransactionAmountStateDataError = () => createSelector(
  [selectVerifyTransactionAmountState],
  cse => cse.error,
)

const selectGetPrescriptionIdState = state => state.consultations.getPrescriptionIdState
const getPrescriptionIdData = () => createSelector(
  [selectGetPrescriptionIdState],
  cse => cse.data,
)

const getPrescriptionIdDataLoading = () => createSelector(
  [selectGetPrescriptionIdState],
  cse => cse.loading,
)

const getPrescriptionIdDataError = () => createSelector(
  [selectGetPrescriptionIdState],
  cse => cse.error,
)

const selectPostRegenerateAgoraTokenState = state => state.consultations.postRegenerateAgoraTokenState
const postRegenerateAgoraTokenData = () => createSelector(
  [selectPostRegenerateAgoraTokenState],
  cse => cse.data,
)

const postRegenerateAgoraTokenLoading = () => createSelector(
  [selectPostRegenerateAgoraTokenState],
  cse => cse.loading,
)

const postRegenerateAgoraTokenError = () => createSelector(
  [selectPostRegenerateAgoraTokenState],
  cse => cse.error,
)

module.exports = {
  getAdminConsultationsList,
  getAdminConsultationsListError,
  getAdminConsultationsListLoading,
  getAdminConsultation,
  getAdminConsultationError,
  getAdminConsultationLoading,
  getCreateAdminConsultation,
  getCreateAdminConsultationError,
  getCreateAdminConsultationLoading,
  getUpdateAdminConsultation,
  getUpdateAdminConsultationError,
  getUpdateAdminConsultationLoading,
  getDeleteAdminConsultationRes,
  getDeleteAdminConsultationError,
  getDeleteAdminConsultationLoading,
  getUpdateStatusAdminConsultation,
  getUpdateStatusAdminConsultationError,
  getUpdateStatusAdminConsultationLoading,

  getConsultationsList,
  getConsultationsListError,
  getConsultationsListLoading,
  getAvailableConsultationsList,
  getAvailableConsultationsListLoading,
  getAvailableConsultationsListError,
  createConsultation,
  createConsultationError,
  createConsultationLoading,
  getConsultationsHistoryList,
  getConsultationsHistoryListError,
  getConsultationsHistoryListLoading,
  getConsultationHistoryDetails,
  getConsultationHistoryLoading,
  getConsultationHistoryError,
  getDoctorConsultationHistoryList,
  getDoctorConsultationHistoryListLoading,
  getDoctorConsultationHistoryListError,
  getDoctorConsultationOverview,
  getDoctorConsultationOverviewLoading,
  getDoctorConsultationOverviewError,
  assignDocToConsultationData,
  assignDocToConsultationLoading,
  assignDocToConsultationError,
  selectSetConsultationPreference,
  selectSetConsultationPreferenceLoading,
  selectSetConsultationPreferenceError,
  selectPatientConsultationRecord,
  selectPatientConsultationRecordLoading,
  selectPatientConsultationRecordError,
  selectPostDoctorNotes,
  selectPostDoctorNotesLoading,
  selectPostDoctorNotesError,
  selectPostDoctorMC,
  selectPostDoctorMCLoading,
  selectPostDoctorMCError,
  selectPostDoctorReferral,
  selectPostDoctorReferralLoading,
  selectPostDoctorReferralError,
  selectEndDoctorConsultationData,
  selectEndDoctorConsultationLoading,
  selectEndDoctorConsultationError,
  selectAudioCallByDocData,
  selectAudioCallByDocDataLoading,
  selectAudioCallByDocDataError,
  selectGetDoctorTwilioTokensData,
  selectGetDoctorTwilioTokensDataLoading,
  selectGetDoctorTwilioTokensDataError,
  selectPostDocConsultationTimeLapsedData,
  selectPostDocConsultationTimeLapsedLoading,
  selectPostDocConsultationTimeLapsedError,
  selectMDReferralNewLinkData,
  selectMDReferralNewLinkDataLoading,
  selectMDReferralNewLinkDataError,
  selectMDMcNewLinkData,
  selectMDMcNewLinkDataLoading,
  selectMDMcNewLinkDataError,
  selectPatientConsultationStatusData,
  selectPatientConsultationStatusDataLoading,
  selectPatientConsultationStatusDataError,
  verifyTransactionAmountStateData,
  verifyTransactionAmountStateDataLoading,
  verifyTransactionAmountStateDataError,
  getPrescriptionIdData,
  getPrescriptionIdDataLoading,
  getPrescriptionIdDataError,
  postRegenerateAgoraTokenData,
  postRegenerateAgoraTokenLoading,
  postRegenerateAgoraTokenError,
}
